// extracted by mini-css-extract-plugin
module.exports = {"root":"form_root__1325X"};